import React from 'react';
import ImageComponent from 'atoms/Image';
import { getFullImagePath, getMainImagePath, getBackgroundImageSrc } from 'common/utilities/utils';
import { getFilteredItemsFavOrders } from 'organisms/AccountPage/AU/accountPageUtils';
import { currencyConversion } from 'organisms/PaymentProcess/Presentation/orderReceivedScreenFn';

const FavItemSection = props => {
  const { occassionOrder, tenantReducer, imageContainerSize, plpbackgroundImageData } = props;

  const { currencySymbol, addHope, carryBag, currencyConversionFactor } = tenantReducer;
  const { items } = occassionOrder;
  let filteredItems = getFilteredItemsFavOrders(items, addHope, carryBag);
  const plpBackgroundStyle = () =>
    getBackgroundImageSrc(plpbackgroundImageData, imageContainerSize.width, imageContainerSize.height);
  return (
    <React.Fragment>
      {filteredItems?.map(ordereditem => {
        return (
          <div className='account-accordian-details-section'>
            <div className='option-section option-section-fav-menu default-img'>
              <div style={plpBackgroundStyle()} className='product-image-parent-container-fav-menu'>
                {ordereditem.content && (
                  <ImageComponent
                    className='favourite-order-img-sopac'
                    srcFile={getMainImagePath(ordereditem.content, imageContainerSize.width, imageContainerSize.height)}
                    alt={'No-Image'}
                    defaultPath={getFullImagePath(ordereditem.imageName, tenantReducer, true)}
                  />
                )}
              </div>

              <div className='favourite-order-details fav-order-details-global'>
                <span className='fav-orders-item-name'>
                  {ordereditem?.quantity}x {ordereditem?.name}
                </span>

                <span className='fav-item-price'>
                  {currencySymbol}
                  {currencyConversion(ordereditem?.price, currencyConversionFactor)}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default FavItemSection;
